import {MODAL_LOCAL_STORAGE_KEYS, PHARMACY_ORDERS_INSTRUCTION_ITEM} from '@/reference/modal-instruction-items';
import {Reference} from "smd-vue-scaffold";

import ModalInstructions from '@/modals/modal-instructions/modal-instructions';
import ModalSuggestService from "@/modals/modal-suggest-service";
import Routes from '@/router/routes';
import ServicesCardItem from '@/reference/services-card-items';
import ShowModalInstructionMixin from '@/mixins/show-modal-instructions-mixin';
import GetElementString from '@/mixins/get-element-string';

export default {
  name: "m-root-services-find-service",
  mixins: [GetElementString, ShowModalInstructionMixin],
  methods: {
    handleCardSelection(labelId) {
      if (labelId === 'txt019') {
        if (this.showModalInstructions(MODAL_LOCAL_STORAGE_KEYS.PHARMACY_ORDERS)) {
          this.$modal.open({
            component: ModalInstructions,
            position: 'detached auto-height',
            props: {
              items: PHARMACY_ORDERS_INSTRUCTION_ITEM,
              proceedTo: Routes.PHARMACY_ORDERS,
              mainTitle: 'txt346',
              modalLocalStorageKey: MODAL_LOCAL_STORAGE_KEYS.PHARMACY_ORDERS
            },
            size: Reference.SmdModalSizes.xs,
          })
        } else {
          this.$router.push({
            name: Routes.PHARMACY_ORDERS
          })
        }
      } else if (labelId === 'txt020') {
        this.$router.push({
          name: Routes.LAB_REQUESTS
        })
      } else if (labelId === 'txt025') {
        this.$modal.open({
          component: ModalSuggestService,
          size: Reference.SmdModalSizes.xs,
          position: 'detached auto-height',
        })
      }
    },
    getTitle(card) {
      return this.getElementString(card.labelId).replace('COMING SOON', '');
    },
    getSubTitle(card) {
      return card.disabled ? this.getElementString('txt621__desktop') : '';
    },
    getDescription(card) {
      return card.description ? this.getElementString(card.description) : '';
    }
  },
  ServicesCardItem
}